"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationChannel = void 0;
var CommunicationChannel;
(function (CommunicationChannel) {
    CommunicationChannel["RemarketingEmail"] = "remarketing_email";
    CommunicationChannel["RemarketingSms"] = "remarketing_sms";
    CommunicationChannel["TransactionalEmail"] = "transactional_email";
    CommunicationChannel["TransactionalSms"] = "transactional_sms";
})(CommunicationChannel || (exports.CommunicationChannel = CommunicationChannel = {}));
